
<template>
<div class="login" >
  <div class="lange-dropdown">
    <lls-dropdown  @command="handleChangeLang">
          <span class="lls-dropdown-link align-center">
            <span :class="langString === 'CN' ? 'cn-img' : 'us-img'"></span>{{ langString }}
            <i class="lls-icon-arrow-down lls-icon--right"></i>
          </span>
          <lls-dropdown-menu slot="dropdown">
            <lls-dropdown-item command="en">
              <span class="us-img"></span>EN
            </lls-dropdown-item>
            <lls-dropdown-item command="zh">
              <span class="cn-img"></span>CN
            </lls-dropdown-item>
          </lls-dropdown-menu>
        </lls-dropdown>
  </div>
  <div class="log-out" @click.once="logout">
    <img src="~@/static/projectImg/login/log_out.svg" alt="Log out" />
     <!-- Log out -->
  </div>
  <div class="root-wrap">
    <div class="left-root" :style="{ backgroundImage: 'url(' + getDispositionMap.backgroundImage + ')' }">

    </div>
    <div class="right-root">
      <div class="content-wrap">
        <div class="step-wrap" >
          <Step1 
            :isOpen="isOpen"
            @next="handleStep1Next"
            @done="checkInitInfo"
            @open="isOpen = 1">
          </Step1>
        </div>
    
        <div class="step-wrap" v-if="isOpen === 2">
          <div class="step-title">
            {{ $t('preApprovalLogin.revenue') }}
          </div>
          <div class="step-info">
            {{ $t('preApprovalLogin.description2') }}
          </div>
          <lls-button
            type="primary"
            class="add-commerce-account"
            @click="handleGrant"
          >
            <i class="el-icon-plus"></i>
            {{ $t('preApprovalLogin.commerceAccount') }}
          </lls-button>
    
          <Step2Recommend v-if="tableData.length === 0"></Step2Recommend>
          <template v-else>
            <Table 
              :tableData="tableData"
              style="margin-top: 30px;">
            </Table>
            <lls-pagination
              simple
              layout="prev, pager, next"
              :total="total"
              @current-change="changePagination"
              style="text-align: end;"
            >
            </lls-pagination>
          </template>

          <lls-button 
            v-if="tableData.length > 0" 
            type="primary" 
            @click="handleNext"
            class="next-btn"
            style="margin: 27px 0 9px;">
            {{ $t('preApprovalLogin.next') }}
          </lls-button>
        </div>
        <template v-else>
          <div v-if="step2Done" class="step-wrap" >
            <div class="card-bottom">
              <p class="title success">
                <span>
                  <i class="lls-icon-success"></i>{{ $t('preApprovalLogin.revenue') }}
                </span>
                <i class="lls-icon-edit-outline" @click="handleOpen"></i>
              </p>
              <p class="tip">{{ $t('preApprovalLogin.dataSynced', { count: tableData.length }) }}</p>
            </div>
          </div>
      
          <div v-else class="card-bottom">
            <div class="card-info">
              <p class="title">{{ $t('preApprovalLogin.revenue') }}</p>
              <p class="tip">{{ $t('preApprovalLogin.description2') }}</p>
            </div>
          </div>
        </template>
    
        <div class="step-wrap" v-if="isOpen === 3" >
          <template>
            <div class="step-title">
              {{ $t('preApprovalLogin.settlementData') }}
            </div>
            <div class="step-info">
              {{ $t('preApprovalLogin.description3') }}
            </div>
      
            <ConnectDataTable
              ref="connectDataTableRef"
              :tableData="tableData2"
              style="margin-top: 30px;"
              @success="submitSuccess"
              @error="submitError">
            </ConnectDataTable>
            <lls-button
              type="primary"
              @click="handleSubmit"
              class="next-btn"
              style="margin: 27px 0 9px;"
              :loading="btnLoading">
              {{ $t('preApprovalLogin.submit') }}
            </lls-button>
          </template>
        </div>
        <template v-else>
          <div v-if="step3Done" class="step-wrap" >
            <div class="card-bottom">
              <p class="title success">
                <span>
                  <i class="lls-icon-success"></i> {{ $t('preApprovalLogin.settlementData') }}
                </span>
                <i class="lls-icon-edit-outline" @click="isOpen = 3"></i>
              </p>
              <p class="tip">{{ $t('preApprovalLogin.dataSynced', { count: tableData2.length }) }}</p>
            </div>
          </div>
    
          <div v-else class="card-bottom">
            <div class="card-info">
              <p class="title">{{ $t('preApprovalLogin.settlementData') }}</p>
              <p class="tip">{{ $t('preApprovalLogin.description3') }}</p>
            </div>
          </div>
        
        </template>
        
      </div>
    </div>
  </div>

  <lls-dialog
    custom-class="select-platform-dialog"
    title=""
    :visible.sync="selectPlatformDialog"
    :close-on-click-modal="true"
    width="694px"
  >
    <Dialog 
      v-if="selectPlatformDialog"
      :initStep="initDialogStep"
      @refreshData="fetchData(); fetchData2()"
      @close="selectPlatformDialog = false"
      >
    </Dialog>
  </lls-dialog>

  <lls-dialog
    custom-class="select-platform-dialog"
    title=""
    :visible.sync="submitSuccessDialog"
    :close-on-click-modal="true"
    width="694px"
  >
  <div class="success-status">
    <div class="check-icon-wrap">
      <i class="el-icon-check"></i>
    </div>
    <div class="icon-txt">{{ $t('preApprovalLogin.submitSuccess') }}</div>
    <div class="icon-des">
      <span v-html="$t('preApprovalLogin.emailTip')"></span>
    </div>
  </div>
  <lls-button 
    type="primary" 
    @click="handleDone" 
    class="next-btn"
    style="margin: 80px 0 9px;">
    {{ $t('preApprovalLogin.done') }}
  </lls-button>
  
  </lls-dialog>
</div>
</template>

<script>
import { mapGetters } from 'vuex'
// import { listMarketplaceRegion } from "@/api/kj-sys/authorization"
import Step2Recommend from './com/Step2Recommend.vue'
import Step1 from './com/Step1.vue'
import Table from './com/Table.vue'
import ConnectDataTable from './com/ConnectDataTable.vue'
import Dialog from './com/Dialog.vue'
export default {
  name: 'preApproval ',
  components: {
    Table,
    Step1,
    Step2Recommend,
    Dialog,
    ConnectDataTable
  },
  
  data() {
    return {
      chrome: require('@/static/projectImg/login/chrome.png'),
      plugApp: require('@/static/projectImg/login/plug-app.png'),
      activeId: '', 
      selectPlatformDialog: false,
      count: 60,
      timeKey: null,
      activeRegionId: '',
      regionList: [],
      curLang: localStorage.getItem("locale"),  // zh / en
      submitSuccessDialog: false,
      isOpen: 1,
      step2Done: false,
      step3Done: false,
      tableData: [],
      tableData2: [],
      total: 0,
      total2: 0,
      btnLoading: false,
      initDialogStep: 0,
      langString: localStorage.getItem("locale") == 'zh' ? 'CN' : 'EN',
    }
  },
  computed: {
    ...mapGetters(['getDispositionMap'])
  },
  created() {
  },
  async mounted() {
    this.getToken()
  },
  methods: {
    handleChangeLang(lang) {
      localStorage.setItem('locale', lang)
      this.$i18n.locale = lang
      if (lang == 'zh') {
        this.langString = 'CN'
      } else {
        this.langString = 'EN'
      }
      //通知子应用更新
      this.$setGlobalState({ langlocale: lang })
      window.location.reload()
    },
    getToken () {
      this.$API.system.getTokenByEnterpriseId({}).then((res) => {
        localStorage.setItem('tokenByEnterpriseId', res.data.data)
        document.cookie = `tokenByEnterpriseId=${res.data.data}`;
      })
    },
    changePagination (val) {
      this.fetchData(val)
    },
    fetchData(current = 1) {
      return this.$API.system.pageAuthorizedStores({
        size: 10,
        current
      }).then((res) => {
        const data = res.data.data
        let list = data.records || []

        this.total = Number(data.total) // 总条数

        this.tableData = this.resortData(list)

        if (this.tableData.length > 0) {
          // 当列表有数据，则代表第 2 步已完成
          this.step2Done = true 
        }
      })
    },
    fetchData2() {
      return this.$API.system.pageAuthorizedStores({
        size: 999,
        current: 1
      }).then((res) => {
        const data = res.data.data
        let list = data.records || []

        this.total2 = Number(data.total) // 总条数

        this.tableData2 = this.resortData(list)
        if (this.tableData2.length > 0) {
          // 当列表有数据 且 谷歌平台都已经上传文件，则代表第 3 步已完成
          const amazonList = this.tableData2.filter(item => item.platform === 'Amazon SC')
          const flag = amazonList.every(item => item.fileList.length > 0)
          this.step3Done = flag
        }
      })
    },
    // 重构数据
    resortData(list) {
      return list.map(item => {
        let fileList = item.fileList || []
        fileList = fileList.map(file => {
          return {
            ...file,
            name: file.fileName,
          }
        })
        return {
          ...item,
          fileList
        }
      }) || []
    },
    handleOpen() {
      this.isOpen = 2
    },

    // 第一步的next
    handleStep1Next() {
      this.isOpen = 2
    },
    async checkInitInfo(step1Done) {
      await this.fetchData()
      await this.fetchData2()
      // 判断初始化展开项
      // 特殊判断，成功状态 显示步骤二中的成功弹窗
      if (this.$route.query.status === 'succcess') {
        this.isOpen = 2
        this.selectPlatformDialog = true
        this.initDialogStep = 3
      } else {
        if (!step1Done) {// step1未完成
          this.isOpen = 1
        } else if (this.tableData.length === 0) {// step2未完成
          this.isOpen = 2
        } else if (this.tableData2.length === 0) {// step3未完成
          this.isOpen = 3
        } else if (this.tableData2.length > 0) { 
          // 当列表有数据 且 谷歌平台都已经上传文件，则代表第 3 步已完成
          const amazonList = this.tableData2.filter(item => item.platform === 'Amazon SC')
          const flag = amazonList.every(item => item.fileList.length > 0)
          if (!flag) { // step2未完成
            this.isOpen = 3
          } else {
            this.isOpen = ''
          }
        }
      }
    },
    async logout() {
      const { productType } = this.$route.query
      try {
        await this.$sso.logout()
        this.$message.success(this.$t('preApprovalLogin.logoutSuccess'))
        this.$router.push({
          path: '/login',
          query: { productType },
        })
        localStorage.clear()
      } catch (e) {
        const errorMessage = JSON.parse(e?.message)?.message
        this.$message.error(
          errorMessage ||
            'The request was not processed successfully. Please try again later!'
        )
      }
    },
    handleGrant() {
      this.selectPlatformDialog = true
      this.initDialogStep = 0 // 初始化
    },
    handleNext() {
      // if (this.tableData.length === 0) {
      //   this.$message.warning('Please add commerce account')
      //   return
      // }
      this.step2Done = true
      this.isOpen = 3
    },
    handleSubmit () {
      this.btnLoading = true
      this.$refs.connectDataTableRef.submitUpload()
    },
    submitSuccess () {
      this.btnLoading = false
      this.step3Done = true
      this.submitSuccessDialog = true
      this.isOpen = '' // 收起
      this.fetchData2()

      setTimeout(() => {
        // 打开弹窗后 5S 跳转到产品中心页面
        this.$router.push({path: '/main-productCenter'});
      }, 5000);
    },
    submitError () {
      this.btnLoading = false
    },
    handleDone() {
      // 跳转到产品中心页面
      this.$router.push({path: '/main-productCenter'});

      // 跳转官网
      // window.open('https://www.linklogis.com.hk/#/Contact', '_blank')
      this.submitSuccessDialog = false
    },
    

  }
}
</script>

<style lang="scss" scoped>
.login {
  height: 100%;
  overflow: auto;
  position: relative;
  // background-size: 100% 100%;
}
.root-wrap {
  display: flex;
  // flex-direction: row-reverse;
  height: 100%;
}

.left-root {
  // height: 100%;
  background-size: cover;
  background-position: 18% center;
  background-repeat: no-repeat;
}
@media (min-width: 900px) {
  .left-root {
    // position: fixed;
    // top: 0px;
    // left: 0px;
    // bottom: 0px;
    width: 380px;
  }
}

@media (min-width: 1200px) {
  .left-root {
    // width: 540px;
    width: 40%;
  }
}

.right-root {
  // width: 60%;
  // box-shadow: 0px 0px 10px 0px #578AD10D;
  background-color: #fff;
  height: 100%;
  padding: 64px;
  box-sizing: border-box;
  overflow: auto;
  flex: 1;
  display: flex;
  justify-content: center;
}
.content-wrap {
  max-width: 800px;
  flex-grow: 1;
}
.step-wrap {
  border: 1px solid #C4C4C480;
  padding: 17px 33px;
  border-radius: 10px;
  box-shadow: rgba(16, 24, 40, 0.06) 0px 2px 6px 0px;
  margin-bottom: 23px;
  position: relative;
  &:hover {
    border: 1px solid #5A9CF880
  }
}
.step-title {
  font-size: 16px;
  font-weight: 600;
  line-height: 21.79px;
  color: #4E78B1;
}
.step-info {
  font-size: 12px;
  font-weight: 400;
  line-height: 16.34px;
  color: #8C8C8C;
  margin: 14px 0;
}
.add-commerce-account {
  width: 100%;
  height: 42px;
  display: flex;
  align-items: center;  
  justify-content: center;
  font-size: 14px;
  font-weight: 500;
  line-height: 14px;
  border: 1px solid #5A9CF8CC;
  background: #5A9CF826;
  color: #5A9CF8;
  border-radius: 7px;
}
.el-icon-plus {
  font-size: 12px;
  font-weight: 600;
}

.dialog-title {
  font-size: 18px;
  font-weight: 700;
  line-height: 24.51px;
  color: #4E78B1;
}
.dialog-des {
  color: #7A7A7A;
  margin-top: 8px;
  font-weight: 400;
  font-size: 14px;
}
::v-deep .select-platform-dialog {
  width: 694px !important;
  // margin-top: calc((100vh - 300px) / 2) !important;
  padding: 28px 51px 20px;
}
::v-deep .next-btn {
  width: 100%;
  height: 42px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: 500;
  line-height: 14px;
  background: linear-gradient(75.35deg, #5A9CF8 16.14%, #90BEFD 100%);
  margin-top: 42px;
  border-radius: 7px;
}
.check-icon-wrap {
  width: 72px;
  height: 72px;
  background: #23A26D1F;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 22px;
  margin-bottom: 10px;

  .el-icon-check {
    border-radius: 50%;
    width: 39px;
    height: 39px;
    background: #23A26D;
    color: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 22px;
  }
}

.success-status {
  display: flex;
  align-items: center;
  flex-direction: column;
  // margin-top: 185px;
}


.icon-txt {
  color:#474747;
  font-size: 20px;
  font-weight: 400;
  line-height: 40px;
  margin-bottom: 10px;
}
.icon-des {
  line-height: 23px;
  font-size: 16px;
  font-weight: 400;
  display: flex;
  align-items: center;
  flex-direction: column;
}
#vue-app-container {
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 100;
  background-color: #000;
  padding: 10px;
}
.card-bottom {
  .card-info {
    padding: 17px 33px;
    border: 1px solid #c4c4c4;
    border-radius: 5px;
    margin: 20px 0 22px;
  }
  .title {
    color: #8b97a8;
    font-weight: 600;
    font-size: 16px;
    margin-bottom: 10px;

    &.success {
      color: #4e78b1;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .lls-icon-success {
        color: #06d6a0;
        margin-right: 4px;
      }

      .lls-icon-edit-outline {
        font-size: 22px;
        color: #c4c4c4;
        cursor: pointer;
        position: absolute;
        right: 30px;
        top: 30px;
      }
    }
  }

  .tip {
    color: #8c8c8c;
    font-size: 12px;
  }
}
.log-out {
  position: absolute;
  top: 10px;
  right: 10px;
  padding: 10px;
  border: 1px solid #A1A8B24D;
  border-radius: 10px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 600;
  z-index: 9;
  background-color: #fff;
  img {
    margin-right: 2px;
  }
}
.cn-img {
  display: inline-block;
  height: 38px;
  width: 40px;
  background: url("~@/assets/CN.svg") no-repeat center/cover;
  vertical-align: middle;
}
.us-img {
  display: inline-block;
  height: 38px;
  width: 40px;
  vertical-align: middle;
  background: url("~@/assets/US.svg") no-repeat center/cover;
}
.lange-dropdown{
  position: absolute;
  top: 14px;
  right: 64px;
  .align-center {
    display: flex;
    align-items: center;
  }
}
</style>
